import { useSnackbar } from "notistack";

export const useErrorHandler = () => {
  const { enqueueSnackbar } = useSnackbar();
  return (
    error
    // cases = [],
    // def = { message: "اتفاقی افتاده، لطفا بعدا تلاش کنید." }
  ) => {
    // let message = def.message;
    // let variant = def.variant || "error";
    // let callback;
    // for (const {
    //   case: _c,
    //   message: _m,
    //   variant: _v = "error",
    //   callback: _cb,
    // } of cases) {
    //   if (_c === error) {
    //     message = _m;
    //     variant = _v;
    //     callback = _cb;
    //     break;
    //   }
    // }
    enqueueSnackbar(error?.message || "اتفاقی افتاده، لطفا بعدا تلاش کنید.", {
      variant: "error",
    });
    // if (callback) callback();
  };
};
